import { endpointDeclaration } from '@moojo/endpoints'
import { z } from 'zod'

export const EngageRequest = z.object({})

export type EngageRequest = z.infer<typeof EngageRequest>

export const EngageResponse = z.unknown()

export type EngageResponse = z.infer<typeof EngageResponse>

export const engageDeclaration = endpointDeclaration(EngageRequest, EngageResponse)
